export const API = {
  BaseURL: import.meta.env.VITE_API_BASE_URI,
  timeout: parseInt(import.meta.env.VITE_API_TIMEOUT),
  contentType: 'application/json',
  endpoints: {
    ReconCommentsData: import.meta.env.VITE_API_DENODO + '/recon-comments',
    ReconGridData: import.meta.env.VITE_API_DENODO + '/recon-grid',
    ReconGridDataDetails: import.meta.env.VITE_API_DENODO + '/recon-details',
    ReconGridAnalysts: import.meta.env.VITE_API_DENODO + '/recon-analysts',
    ReconGridExportCSV: import.meta.env.VITE_API_DENODO + '/',

    SaveComment: import.meta.env.VITE_API_SQL + '/comment',
  },
  errorMessages: {
    none2xx: 'The request was made and the server responded with a status code that falls out of the range of 2xx',
    noResponse: 'The request was made but no response was received',
    timeout: "We are unable to fetch data at this time, kindly check your internet connection and we'll reconnect you.",
    unexpectedError: 'Something happened in setting up the request that triggered an Error',
  },
};
